export default __webpack_public_path__ + "static/media/garfo.817fce97.svg";